// AUTO-GENERATED by scripts/generate-content.js — do not edit by hand.
// Edit the articles via the /admin CMS, or the JSON files in content/news/.

const newsArticles = [
  {
    "id": 1,
    "title": "Ninsun Biotech selected to present e-poster at Onco Startup Summit 2026",
    "excerpt": "Ninsun Biotech is selected among 48 startups in oncology to present an e-poster at the Onco Startup Summit held in Paris.",
    "content": "Ninsun Biotech is selected among 48 startups in oncology to present an e-poster at the Onco Startup Summit held in Paris, France, during the French national congress of Oncology organized by IFODS.",
    "publishedDate": "2026-06-18",
    "category": "Events",
    "image": "/img/logo.png",
    "externalUrl": "",
    "slug": "onco-startup-summit-2026"
  },
  {
    "id": 2,
    "title": "Ninsun Biotech launches its first clinical study with one of Europe’s leading cancer centers, Institut Curie, Paris, France",
    "excerpt": "Ninsun Biotech launches its first clinical study with one of Europe’s leading cancer centers,\nInstitut Curie, Paris, France. The study is led by Prof. Nicolas GIRARD, Head of Medical\nOncology Dpt.",
    "content": "Ninsun Biotech launches its first clinical study with one of Europe’s leading cancer centers,\nInstitut Curie, Paris, France. The study is led by Prof. Nicolas GIRARD, Head of Medical\nOncology Dpt.\nThis milestone marks the start of our clinical validation journey focused on a critical challenge in\nlung cancer care: better identifying which patients are most likely to benefit from neoadjuvant\nimmunotherapy.\nToday, these treatments can be highly effective, but not all patients respond equally — and\nbetter predictive tools are urgently needed to guide treatment decisions earlier and more\nprecisely.\nThrough this study, Ninsun aims to generate the first clinical evidence supporting a biomarker-\nbased approach that could help predict treatment response, optimize patient selection, and\nultimately improve outcomes.\nFirst results are expected by the end of 2026 — a key step toward more personalized cancer\ncare",
    "publishedDate": "2026-04-24",
    "category": "Milestones",
    "image": "/img/news/logo.png",
    "externalUrl": "",
    "slug": "clinical-study-institut-curie"
  },
  {
    "id": 3,
    "title": "𝗨𝗻𝗹𝗼𝗰𝗸𝗶𝗻𝗴 𝘁𝗵𝗲 𝗳𝘂𝘁𝘂𝗿𝗲 𝗼𝗳 𝗰𝗮𝗻𝗰𝗲𝗿 𝘁𝗿𝗲𝗮𝘁𝗺𝗲𝗻𝘁 𝘀𝘁𝗮𝗿𝘁𝘀 𝘄𝗶𝘁𝗵 𝘁𝗮𝗿𝗴𝗲𝘁𝗶𝗻𝗴 𝗶𝘁𝘀 𝗿𝗼𝗼𝘁 𝗰𝗮𝘂𝘀𝗲: 𝗰𝗮𝗻𝗰𝗲𝗿 𝘀𝘁𝗲𝗺 𝗰𝗲𝗹𝗹𝘀 (𝗖𝗦𝗖𝘀)",
    "excerpt": "Revolutionary breakthrough in cancer stem cell targeting technology shows promising results in clinical trials.",
    "content": "𝗨𝗻𝗹𝗼𝗰𝗸𝗶𝗻𝗴 𝘁𝗵𝗲 𝗳𝘂𝘁𝘂𝗿𝗲 𝗼𝗳 𝗰𝗮𝗻𝗰𝗲𝗿 𝘁𝗿𝗲𝗮𝘁𝗺𝗲𝗻𝘁 𝘀𝘁𝗮𝗿𝘁𝘀 𝘄𝗶𝘁𝗵 𝘁𝗮𝗿𝗴𝗲𝘁𝗶𝗻𝗴 𝗶𝘁𝘀 𝗿𝗼𝗼𝘁 𝗰𝗮𝘂𝘀𝗲: 𝗰𝗮𝗻𝗰𝗲𝗿 𝘀𝘁𝗲𝗺 𝗰𝗲𝗹𝗹𝘀 (𝗖𝗦𝗖𝘀)",
    "publishedDate": "2025-01-15",
    "category": "Research",
    "image": "https://media.licdn.com/dms/image/v2/D4E22AQE0JZm31BUfJg/feedshare-shrink_800/B4EZd4QkqLG4Ag-/0/1750069303040?e=2147483647&v=beta&t=XtJTsEeRfn7nJamYAuSzc1iIiFoajkmXWQnhZ3bYAV8",
    "externalUrl": "https://www.linkedin.com/posts/ninsun-biotech_thanks-to-bioark-for-his-presence-by-our-activity-7351172131554033664-IjHW",
    "slug": "cancer-stem-cell-breakthrough"
  }
];

export const categories = [
  {
    "value": "all",
    "label": "All News"
  },
  {
    "value": "Events",
    "label": "Events"
  },
  {
    "value": "Research",
    "label": "Research"
  },
  {
    "value": "Milestones",
    "label": "Milestones"
  },
  {
    "value": "Partnerships",
    "label": "Partnerships"
  },
  {
    "value": "Regulatory",
    "label": "Regulatory"
  },
  {
    "value": "Funding",
    "label": "Funding"
  }
];

export { newsArticles };
